import { IconProps } from ".";
import Icon from "./assets/doc_24_docx.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24DocDocx(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
